export default {
  ERROR: 'ERROR',

  // registration and profile
  SELECT_LANGUAGE_NEXT: 'SELECT_LANGUAGE_NEXT',
  REGISTRATION_FLOW: 'REGISTRATION_FLOW',
  CLOSE_OTP_SENT_ALERT: 'CLOSE_OTP_SENT_ALERT',
  NEW_USER: 'NEW_USER',
  EXISTING_USER: 'EXISTING_USER',
  UPDATE_USER: 'UPDATE_USER',
  EXPO_PUSH_TOKEN: 'EXPO_PUSH_TOKEN',
  SHOW_OTP: 'SHOW_OTP',
  SEND_OTP: 'SEND_OTP',
  CANCEL_OTP_CODE: 'CANCEL_OTP_CODE',
  CURRENT_USER: 'CURRENT_USER',
  STORE_SESSION_ID: 'STORE_SESSION_ID',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  FEEDBACK: 'FEEDBACK',
  ONBOARDING_COMPLETED: 'ONBOARDING_COMPLETED',
  EMAIL_OR_PHONE: 'EMAIL_OR_PHONE',
  EMAIL_OR_PHONE_ERROR: 'EMAIL_OR_PHONE_ERROR',
  CLEAR_EMAIL_OR_PHONE_ERROR: 'CLEAR_EMAIL_OR_PHONE_ERROR',
  TERMS_PRIVACY: 'TERMS_PRIVACY',
  ACCEPT_TERMS_PRIVACY: 'ACCEPT_TERMS_PRIVACY',
  ENTER_EMAIL: 'ENTER_EMAIL',
  CLEAR_EMAIL_ERROR: 'CLEAR_EMAIL_ERROR',
  CLEAR_ENTER_EMAIL: 'CLEAR_ENTER_EMAIL',
  VERIFY_EMAIL: 'VERIFY_EMAIL',
  EMAIL_VERIFIED: 'EMAIL_VERIFIED',
  UNSUBSCRIBE_EMAIL: 'UNSUBSCRIBE_EMAIL',
  SKIP_EMAIL: 'SKIP_EMAIL',
  ENTER_PHONE: 'ENTER_PHONE',
  CLEAR_PHONE_ERROR: 'CLEAR_PHONE_ERROR',
  RESET_PASSWORD: 'RESET_PASSWORD',
  OPEN_DELETE_ACCOUNT: 'OPEN_DELETE_ACCOUNT',
  CLOSE_DELETE_ACCOUNT: 'CLOSE_DELETE_ACCOUNT',
  LOAD_TEFAP_CONFIG: 'LOAD_TEFAP_CONFIG',

  // pantries
  LOAD_PANTRIES: 'LOAD_PANTRIES',
  SET_LOCATION: 'SET_LOCATION',
  SHOW_PANTRY_DETAILS: 'SHOW_PANTRY_DETAILS',
  CLOSE_PANTRY_DETAILS: 'CLOSE_PANTRY_DETAILS',
  OPEN_MAKE_APPOINTMENT: 'OPEN_MAKE_APPOINTMENT',
  CLOSE_MAKE_APPOINTMENT: 'CLOSE_MAKE_APPOINTMENT',
  OPEN_MUST_VERIFY: 'OPEN_MUST_VERIFY',
  CLOSE_MUST_VERIFY: 'CLOSE_MUST_VERIFY',
  MAKE_APPOINTMENT: 'MAKE_APPOINTMENT',
  OPEN_CANCEL_APPOINTMENT: 'OPEN_CANCEL_APPOINTMENT',
  CLOSE_CANCEL_APPOINTMENT: 'CLOSE_CANCEL_APPOINTMENT',
  OPEN_CHANGE_APPOINTMENT: 'OPEN_CHANGE_APPOINTMENT',
  CLOSE_CHANGE_APPOINTMENT: 'CLOSE_CHANGE_APPOINTMENT',
  CONFIRM_APPOINTMENT: 'CONFIRM_APPOINTMENT',
  CANCEL_APPOINTMENT: 'CANCEL_APPOINTMENT',
  CONFIRM_CANCEL_APPOINTMENT: 'CONFIRM_CANCEL_APPOINTMENT',
  RESERVATIONS_QUEUE: 'RESERVATIONS_QUEUE',
  REFRESH: 'REFRESH',
  PANTRY_LOGOUT: 'PANTRY_LOGOUT',
  OPEN_SELECT_EDIT_CANCEL: 'OPEN_SELECT_EDIT_CANCEL',
  CLOSE_SELECT_EDIT_CANCEL: 'CLOSE_SELECT_EDIT_CANCEL',
  SELECT_EDIT_CANCEL_VISIT: 'SELECT_EDIT_CANCEL_VISIT',
  CLOSE_RESERVATION_CONFIRMED: 'CLOSE_RESERVATION_CONFIRMED',
  OPEN_SCREEN_TEFAP_ATTESTATION: 'OPEN_SCREEN_TEFAP_ATTESTATION',
  CLOSE_SCREEN_TEFAP_ATTESTATION: 'CLOSE_SCREEN_TEFAP_ATTESTATION',
  OPEN_SCREEN_MISSING_INFO: 'OPEN_SCREEN_MISSING_INFO',
  CLOSE_SCREEN_MISSING_INFO: 'CLOSE_SCREEN_MISSING_INFO',
  COMPLETE_SCREEN_TEFAP_ATTESTATION: 'COMPLETE_SCREEN_TEFAP_ATTESTATION',
  OPEN_MUST_LOGIN: 'OPEN_MUST_LOGIN',
  CLOSE_MUST_LOGIN: 'CLOSE_MUST_LOGIN',
  SET_PANTRY_FILTER: 'SET_PANTRY_FILTER',

  // search (Algolia global search)
  SEARCH_PANTRIES_REQUEST: 'SEARCH_PANTRIES_REQUEST',
  SEARCH_PANTRIES_SUCCESS: 'SEARCH_PANTRIES_SUCCESS',
  SEARCH_PANTRIES_FAILURE: 'SEARCH_PANTRIES_FAILURE',
  CLEAR_SEARCH: 'CLEAR_SEARCH',

  // explore mode (map-bounded pantries)
  FETCH_EXPLORE_PANTRIES_REQUEST: 'FETCH_EXPLORE_PANTRIES_REQUEST',
  FETCH_EXPLORE_PANTRIES_SUCCESS: 'FETCH_EXPLORE_PANTRIES_SUCCESS',
  FETCH_EXPLORE_PANTRIES_FAILURE: 'FETCH_EXPLORE_PANTRIES_FAILURE',

  // visits
  GET_VISITS: 'GET_VISITS',
  ADD_VISIT: 'ADD_VISIT',
  REMOVE_VISIT: 'REMOVE_VISIT',
  SELECT_VISIT: 'SELECT_VISIT',
  UPDATE_VISIT: 'UPDATE_VISIT',

  // updates
  GET_UPDATES: 'GET_UPDATES',
  GET_THREAD: 'GET_THREAD',
  CLOSE_THREAD: 'CLOSE_THREAD',
};
